import { useEffect, useState } from "react";
import { default as signUpService } from "../services/signUp"
import { SignUpDataAPI, SignUpResponseError, State } from "../types/signup";
import { AxiosError } from "axios";
import { useNavigate, useSearchParams } from "react-router";
import { GetSignUpUserDataResponse } from "@/types/models/services";


export const useSignUp = () => {
  const navigate = useNavigate();

  const [userData, setUserData] = useState<GetSignUpUserDataResponse | undefined>()
  const [state, setState] = useState<State>("idle");
  const [errors, setErrors] = useState<SignUpResponseError["errors"]>();
  const [searchSingUpParams] = useSearchParams();

  useEffect(() => {
    const signUpDataToken = searchSingUpParams.get('singUpParams') || '';

    if (signUpDataToken) {
      signUpService.getSignUpUserData(signUpDataToken)
      .then((data) => {
        if (data) {
          setUserData(data)
        }
      });

      const newSearchParams = new URLSearchParams(searchSingUpParams);
      newSearchParams.delete('singUpParams');
      navigate({
        pathname: window.location.pathname,
        search: newSearchParams.toString()
      }, { replace: true })
    }
  }, [searchSingUpParams, navigate])

  const removeError = (field: keyof SignUpResponseError["errors"]) => {
    setErrors({...errors, [field]: undefined});
  }

  const confirmForm = (data: SignUpDataAPI) => {
    setState("submitting");
    signUpService.confirmSignUp(data)
    .then((res) => {
      setState("submitted");
    })
    .catch((err: AxiosError<SignUpResponseError>) => {
      setState("idle");
      setErrors(err.response?.data.errors);
    })
  }

  return {
    errors,
    state,
    userData,
    confirmForm,
    removeError,
  }
}